module.exports = __webpack_public_path__ + "static/media/ALC_GKB_Web_-2.a6b42688.JPG";